import { render } from "./AppFooter.vue?vue&type=template&id=4b42a366&scoped=true"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=4b42a366&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b42a366"]])

export default __exports__